import { toast } from "react-toastify";
import { TRatePerTypes } from "../types/trades/trades";

export let cropSizeOptions = [
  { label: "Golti (25mm to 35mm)", value: "GOLTI" },
  { label: "Golta (35mm to 45mm)", value: "GOLTA" },
  { label: "Medium (45mm to 55mm)", value: "MEDIUM" },
  { label: "Mini Mukkal (50mm to 60mm)", value: "MINI_MUKKAL" },
  { label: "Mukkal (55mm to 60mm)", value: "MUKKAL" },
  { label: "Large (60mm to 70mm)", value: "LARGE" },
  { label: "Extra Large (70mm+)", value: "EXTRA" },
  { label: "Family Pack (Varied Sizes)", value: "FAMILY_PACK" },
];
export let cropPackagingOptions = [
  { label: "Bags", value: "BAGS" },
  { label: "Crates", value: "CRATES" },
  { label: "Boxes", value: "BOXES" },
  { label: "Sacs", value: "SACS" },
  { label: "Pieces", value: "PIECES" },
];
export let cropQualityOptions = [
  { label: "Premium", value: "PREMIUM" },
  { label: "Best", value: "BEST" },
  { label: "Average", value: "AVERAGE" },
  { label: "Super Average", value: "SUPER_AVERAGE" },
];
export let dispatchAtOptions = [
  { label: "Early morning (4AM - 8AM)", value: "4AM - 8AM" },
  { label: "Before Noon (8AM - 12PM)", value: "8AM - 12PM" },
  { label: "Afternoon (12PM - 4PM)", value: "12PM - 4PM" },
  { label: "Evening (4PM - 9PM)", value: "4PM - 9PM" },
  { label: "Night (9PM - 4AM)", value: "9PM - 4AM" },
];
export let perKgOptions = [
  {
    label: "Per Kg",
    value: "RATE_PER_KG",
  },
  {
    label: "Per Ton",
    value: "RATE_PER_TON",
  },

  {
    label: "Per Unit",
    value: "RATE_PER_UNIT",
  },
  {
    label: "Per Piece",
    value: "RATE_PER_PIECE",
  },
];
export let freightPerKgOptions = [
  {
    label: "Per Kg",
    value: "RATE_PER_KG",
  },
  {
    label: "Per Ton",
    value: "RATE_PER_TON",
  },

  {
    label: "Per Unit",
    value: "RATE_PER_UNIT",
  },
  {
    label: "Per Truck",
    value: "RATE_PER_TRUCK",
  },
];
// formulassss
export const toNum = (v: string): number | "" => {
  return v.trim() === "" ? "" : Number(v);
};

export const getIndSpotCommodityCost = (
  rate: number,
  weight: number,
  rateUnit: string | number,
  qty: number
) => {
  let val = 0;
  if (rateUnit === TRatePerTypes.kgs) {
    val = rate * weight;
  } else if (rateUnit === TRatePerTypes.tons) {
    val = rate * (weight / 1000);
  } else if (
    rateUnit === TRatePerTypes.unit ||
    rateUnit === TRatePerTypes.piece
  ) {
    val = rate * qty;
  }
  return val;
};

export const getIndLandingRate = (invoice: number, weight: number) => {
  let landing = invoice / weight;
  return landing;
};

export const getIndLandingInvoiceCost = (
  rate: number,
  weight: number,
  rateUnit: string | number,
  qty: number
) => {
  let val = 0;
  if (rateUnit === TRatePerTypes.kgs) {
    val = rate * weight;
  } else if (rateUnit === TRatePerTypes.tons) {
    val = rate * (weight / 1000);
  } else if (
    rateUnit === TRatePerTypes.unit ||
    rateUnit === TRatePerTypes.piece
  ) {
    val = rate * qty;
  }
  return val;
};
export const getIndSpotRate = (comodity: number, weight: number) => {
  let spotRate = comodity / weight;
  return spotRate;
};

export const getIndWeight = (
  weight: number,
  rateUnit: string | number,
  qty: number
) => {
  let val = 0;
  if (rateUnit === TRatePerTypes.kgs) {
    val = weight;
  } else if (rateUnit === TRatePerTypes.tons) {
    val = weight / 1000;
  } else if (
    rateUnit === TRatePerTypes.unit ||
    rateUnit === TRatePerTypes.piece
  ) {
    val = qty;
  }

  return val;
};
export const getIndFreightRateUnitWeight = (
  weight: number,
  freightRateUnit: string | number,
  qty: number,
  totalFreight?: number
) => {
  let val = 0;
  if (freightRateUnit === TRatePerTypes.kgs) {
    val = weight;
  } else if (freightRateUnit === TRatePerTypes.tons) {
    if (totalFreight === 0) {
      val = weight / 1000;
    } else {
      val = weight;
    }
  } else if (freightRateUnit === TRatePerTypes.unit) {
    val = qty;
  } else if (freightRateUnit === TRatePerTypes.truck) {
    val = weight;
  }

  return val;
};
// todo
export const getArrivalIndFreightRate = (
  freightRate: number,
  totalFreightAmount: number,
  totalWeight: number,
  totalQty: number,
  rateUnitType: string
) => {
  let freightRateVal = freightRate;

  if (
    rateUnitType == TRatePerTypes.unit ||
    rateUnitType == TRatePerTypes.piece
  ) {
    freightRateVal = totalFreightAmount / totalQty;
  } else if (rateUnitType == TRatePerTypes.tons) {
    totalWeight = totalWeight / 1000;
    freightRateVal = totalFreightAmount / totalWeight;
  } else {
    freightRateVal = totalFreightAmount / totalWeight;
  }
  return freightRateVal;
};
export const getTotalFreightCostAmt = (
  freightRate: number,
  totalWeight: number,
  totalQty: number,
  freightRateType: string
) => {
  let val = 0;
  if (freightRateType === TRatePerTypes.kgs) {
    val = freightRate * totalWeight;
  } else if (freightRateType === TRatePerTypes.unit) {
    val = freightRate * totalQty;
  } else if (freightRateType === TRatePerTypes.tons) {
    val = freightRate * (totalWeight / 1000);
  } else if (freightRateType === TRatePerTypes.truck) {
    val = freightRate;
  }

  return val;
};

export const getIndFreightRate = (
  weight: number,
  freightRateUnit: string | number,
  qty: number,
  totalFreight?: number
) => {
  let val = 0;
  if (freightRateUnit === TRatePerTypes.kgs) {
    val = weight;
  } else if (freightRateUnit === TRatePerTypes.tons) {
    val = weight / 1000;
  } else if (freightRateUnit === TRatePerTypes.unit) {
    val = qty;
  } else if (freightRateUnit === TRatePerTypes.truck) {
    val = weight;
  }

  return val;
};

export const getIndFreightCost = (
  freightRate: number,
  weight: number,
  totalFreightAmount: number,
  totalWeight: number,
  totalQty: number,
  rateUnitType: string
) => {
  let val = 0;
  let freightRateVal = freightRate;
  if (totalFreightAmount === 0) {
    val = freightRate * weight;
  } else {
    if (
      rateUnitType == TRatePerTypes.unit ||
      rateUnitType == TRatePerTypes.piece
    ) {
      freightRateVal = totalFreightAmount / totalQty;
    } else {
      freightRateVal = totalFreightAmount / totalWeight;
    }
    val = freightRateVal * weight;
  }

  return {
    indFreightCost: val,
  };
};

export const roundOffNum = (value: number, decimals: number = 0): number => {
  if (!Number.isFinite(value)) return 0;

  const factor = Math.pow(10, decimals);
  const scaled = value * factor;

  const rounded = Math.round(scaled + Number.EPSILON);
  const diff = Math.abs(scaled - rounded);

  if (diff === 0.5) {
    return (rounded % 2 === 0 ? rounded : rounded - 1) / factor;
  }

  return rounded / factor;
};

export const getBalancePayable = ({
  totalReceivable = 0,
  srcPf = 0,
  srcDis = 0,
  outwardPmt = 0,
  refunded = 0,
}: {
  totalReceivable?: number;
  srcPf?: number;
  srcDis?: number;
  outwardPmt?: number;
  refunded?: number;
}) => {
  const baseAmount =
    Number(totalReceivable) -
    Number(srcPf) +
    Number(srcDis) -
    Number(outwardPmt);
  // console.log(
  //   Number(totalReceivable),
  //   Number(srcPf),
  //   Number(srcDis),
  //   Number(outwardPmt),
  //   refunded
  // );
  const diff =
    baseAmount < 0 ? -(Math.abs(baseAmount) - refunded) : baseAmount - refunded;
  // console.log(baseAmount, refunded, diff);
  return diff;
};

export const downloadPdf = async (url: string, agreement: string) => {
  try {
    const response = await fetch(`${url}?t=${Date.now()}`, {
      cache: "no-store",
    });

    const blob = await response.blob();

    const blobUrl = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = blobUrl;

    link.download = `${agreement}.pdf`;

    document.body.appendChild(link);

    setTimeout(() => {
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    }, 100);

    // if (agreement === "TRADE_DEST_TAPAL" || agreement === "TRADE_SRC_TAPAL") {
    //   link.setAttribute("download", `Tapal.pdf`);
    // } else if (
    //   agreement === "TRADE_DEST_PATTI" ||
    //   agreement === "TRADE_SRC_PATTI"
    // ) {
    //   link.setAttribute("download", `Patti.pdf`);
    // } else if (
    //   agreement === "TRADE_SRC_INVOICE" ||
    //   agreement === "TRADE_DEST_INVOICE"
    // ) {
    //   link.setAttribute("download", `Invoice .pdf`);
    // } else if (
    //   agreement === "TRADE_SRC_PF_TAX_INVOICE" ||
    //   agreement === "TRADE_DEST_PF_TAX_INVOICE"
    // ) {
    //   link.setAttribute("download", `PF Invoice.pdf`);
    // } else if (agreement === "TRADE_CONTRACT_AGREEMENT") {
    //   link.setAttribute("download", `Trade Contarct Agrement`);
    // } else if (agreement === "TRADE_ACCEPTANCE_AGREEMENT") {
    //   link.setAttribute("download", `Trade Acceptance Agrement`);
    // } else if (agreement === "TRADE_ADVANCE_AGREEMENT") {
    //   link.setAttribute("download", `Trade Advance Agrement`);
    // }
    // link.download = `${agreement}.pdf`;
    // document.body.appendChild(link);
    // link.click();

    // // Clean up
    // document.body.removeChild(link);
    // window.URL.revokeObjectURL(blobUrl);
  } catch (error) {
    console.error("Error downloading PDF:", error);
    toast.error("Failed to download document.");
  }
};
